// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"2324": "aa022e97","3330": "1852a85d","8795": "631c6af3",}[chunkId] + ".css"
}